import React from "react";
import { useTranslation } from "./hooks/useTranslation";
import { StatusLabel } from "./StatusLabel";
import { ColorOptions } from "./types";
export var ObjectiveStatus = function (_a) {
    var results = _a.results, type = _a.type, _b = _a.active, active = _b === void 0 ? false : _b, size = _a.size;
    var t = useTranslation();
    var _c = contentResultToContentResultLabel(results, type, t, active), color = _c.color, append = _c.append, text = _c.text;
    return React.createElement(StatusLabel, { text: text, color: color, append: append, size: size });
};
export var getScore = function (results) {
    var score = results.scorePercent || results.score;
    return score && "".concat(parseInt(score), "%");
};
export var contentResultToContentResultLabel = function (results, type, t, active) {
    if (t === void 0) { t = function () { return ""; }; }
    if (!results.lastAccessed) {
        return {
            color: ColorOptions.LightGrey,
            append: undefined,
            text: t("Not Accessed"),
        };
    }
    if (["discussion", "external", "kryterion"].includes(type)) {
        if (results.status === "incomplete") {
            return {
                color: ColorOptions.Blue,
                append: undefined,
                text: t("In Progress"),
            };
        }
        if (results.status === "completed") {
            return {
                color: ColorOptions.Green,
                append: undefined,
                text: t("Completed"),
            };
        }
    }
    if (type === "scorm" || type === "video" || type === "quiz") {
        if (results.status === "passed") {
            return {
                color: ColorOptions.Green,
                append: getScore(results),
                text: t("Passed"),
            };
        }
        if (results.status === "failed") {
            return {
                color: ColorOptions.Red,
                append: getScore(results),
                text: t("Failed"),
            };
        }
        if (results.status === "completed") {
            return {
                color: ColorOptions.Green,
                append: undefined,
                text: t("Completed"),
            };
        }
        if (active) {
            if (type === "video") {
                return {
                    color: ColorOptions.Blue,
                    append: results.progress
                        ? "".concat(parseInt(results.progress), "%")
                        : undefined,
                    text: t("Progress"),
                };
            }
            return {
                color: ColorOptions.Blue,
                append: undefined,
                text: t("In Progress"),
            };
        }
        if (results.status === "incomplete") {
            return {
                color: ColorOptions.Blue,
                append: results.progress ? "".concat(parseInt(results.progress), "%") : undefined,
                text: results.progress ? t("Progress") : t("In Progress"),
            };
        }
    }
    switch (results === null || results === void 0 ? void 0 : results.status) {
        case "completed":
            return {
                color: ColorOptions.Green,
                append: undefined,
                text: t("Completed"),
            };
        case "downloaded":
            return {
                color: ColorOptions.Green,
                append: undefined,
                text: t("Downloaded"),
            };
        case "incomplete":
            return {
                color: ColorOptions.Blue,
                append: undefined,
                text: t("Incomplete"),
            };
        case "passed":
            return {
                color: ColorOptions.Green,
                append: getScore(results),
                text: t("Passed"),
            };
        case "failed":
            return {
                color: ColorOptions.Red,
                append: getScore(results),
                text: t("Failed"),
            };
        default:
            return {
                color: ColorOptions.LightGrey,
                append: undefined,
                text: "",
            };
    }
};
